var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{attrs:{"color":_vm.color,"text":""},on:{"click":function($event){$event.stopPropagation();return _vm.signOut.apply(null, arguments)}}},[_vm._v(" Cerrar sesión "),_c('v-icon',[_vm._v("mdi-logout")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }